import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import EditingAct from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingAct';
import Header from 'components/Admin/Reports/ActsReport/EditingActsTable/Header/Header';
import { ChangeHistoryModal } from 'components/common/ChangeHistoryModal/ChangeHistoryModal';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useSelector } from 'store/utils';

const EditingActsTable: FC = () => {
    const acts = useSelector((state) => state.acts.acts);

    const trl = useTrls();

    if (acts.length === 0) {
        return <div>{trl('admin.actsReport.actsTable.empty')}</div>;
    }

    return (
        <>
            <Table fullWidth withStripes bordered>
                <TableHead>
                    <Header />
                </TableHead>
                <TableBody>
                    {acts.map((act, index) => (
                        <EditingAct key={index} act={act} />
                    ))}
                </TableBody>
            </Table>
            <ChangeHistoryModal />
        </>
    );
};

export default EditingActsTable;
